import TableView from "../../ReusableComponents/TableView/TableView"
import { getTelecallingHistory } from "../../apis/BhuMeetTeams/Telecaller/dashboard";
import { useState,useEffect } from "react";
import { AddcallHistory } from "./createCallHistory";
import Popup from "../../ReusableFunctions/Popup";
import { set } from "lodash";
import CallHistoryDetails from "./callHistoryDetail";

export const CallHistoryTable = ({state,campid,onClose,callhistoryData,lastRecord})=>{
    const [callHistory, setcallHistory] = useState([]);
    const [openEditform,setOpenEditForm] = useState(false)
    const [selectedCallHistory,setSelected] = useState(null)
    const [selectedCallHistoryrecord,setselectedCallHistoryrecord] = useState(null)
    const [lastRecordStatus,setlastRecord] = useState(lastRecord)
    const [loading,setLoading] = useState(false)
    const [opencallhistoryModel,setopenCallHistoryModel] = useState(false)

    const [campids,setCampid] = useState(campid)
    
    useEffect(()=>{
        console.log(state)
        getAllCallingHistory()
    },[])

    


    const getAllCallingHistory = async () => {
        // console.log(campids)
        setLoading(true)
        getTelecallingHistory(state.request.id).then(res => {
            // console.log(res)
            callhistoryData(res)
            if(campids != null){
                if(state.request.data){
                    let Count = res.filter(x => {
                        return x.callingQueueID === state.request.Data.queueid && x.current_req_status === state.request.Data.current_req_status
                    })
                    if(Count.length >= 2){
                        setlastRecord(true)
                    }
                }
                let findcampid = res.filter((e)=>e.campid == campids.sid_id)
                // console.log(findcampid)
                findcampid[0]['status'] = campids.callstatus == 'ANSWER' ? 'Completed' : campids.callstatus == 'cancel-Agent' ? 'No Response' : campids.callstatus == 'cancel-Customer' ? "No Response" : campids.callstatus.split(" ").join("").toLowerCase() == 'noanswer' ? "No Response" : 'No Response'
                if(findcampid[0].note == 'NA'){
                    setOpenEditForm(!openEditform)
                    setSelected(findcampid[0])
                }
            }
            setcallHistory(res)
            setLoading(false)
        }).catch(err=>{
            console.log(err)
            setLoading(false)
        })
    }



    return (
        <>
        {openEditform && selectedCallHistory && (
            <>
        <AddcallHistory 
        lastRecord = {lastRecordStatus}
        data={selectedCallHistory}
        open={openEditform}
        onClose={()=>{setOpenEditForm(!openEditform);getAllCallingHistory()}}
        isEdit={true}

        />
        </>
        )
        }
        
        <TableView marginBottom={"15px"}
                    showSrNo
                    loadingHeight={"500px"}
                    isLoading={loading}

                    onClickRow={(row) => {

                        console.log(row)
                        setopenCallHistoryModel(true)
                        setselectedCallHistoryrecord(row)
              
                      }}
                    
                    columns={[
                        { Header: "Call By", accessor: "callbyname", width: "12%" },
                        { Header:"Request Note", accessor:"requestnote",width:"20%"},
                        { Header:"Call Duration", accessor:"time",width:"9%"},
                        { Header: "Note", accessor: "note", width: "20%" },
                        { Header: "Call To", accessor: "call_to", width: "10%" },
                        { Header: "Status", accessor: "status", width: "9%" },

                        { Header: "Date", accessor: "dateadded", isDate: true, format: "dd/mm/yyyy", width: "20%" },
                    ]}
                    count={0}
                    pageSize={15}
                    pageNumber={1}
                    data={callHistory}
                    tableContainerHeight={"400px"}
                    hidePagination={false}
                    headerStyle={{ zIndex: 1 }}
                    activities={{  onClickEdit: (e)=>{
                        // console.log(e)
                        if((e.reqstatus == 'open' || e.note == 'NA') || e.status == 'Completed'){
                            setOpenEditForm(!openEditform)
                            setSelected(e)

                        }else{
                            Popup.alert("ERROR","This History is already Created , You cannot edit","ERROR")
                        }
                        

                    }, canEdit: false }}

                />
                {opencallhistoryModel && <CallHistoryDetails data={selectedCallHistoryrecord} open={opencallhistoryModel} onClose={()=>{setopenCallHistoryModel(false)}}/>}
                
                </>
    )

}